import Workflow, { WorkflowAction } from 'models/Workflow';

import { VALUE_NAMES } from './constants';

// The completed steps a correction would ripple into (design §9) — what the restart-consent step
// lists before anything saves. Shared by Edit Demographics and the Patient Demographics card's
// "Use this value" (OLIO-3252), so the two can't disagree about what a change re-runs.
//
// `names` are referral-level value names that changed; `facetIds` the coverages whose payer or
// member ID changed. A coverage correction re-runs that coverage's own payer search and
// verification — scoped, so fixing one coverage doesn't ask to re-run the other's paid check.
// Empty on a terminal run: the API rejects restarts there.
export function impactedActionsFor(
  workflow: Workflow,
  { names = [], facetIds = [] }: { names?: string[]; facetIds?: string[] }
): WorkflowAction[] {
  if (workflow.isTerminal) return [];

  const fromValues = names.length > 0 ? workflow.impactedActionsBy(names) : [];
  const fromCoverages = facetIds.flatMap((facetId) =>
    workflow.impactedActionsBy([VALUE_NAMES.PAYER_NAME, VALUE_NAMES.MEMBER_ID], [facetId])
  );

  return [...fromValues, ...fromCoverages].filter(
    (action, index, all) => all.findIndex((other) => other.id === action.id) === index
  );
}
